import { TimeRangeEnum } from '@Dashboard/TimeRangeSelector';
import { dayjs } from '@Utils/time';
import { useTranslation } from 'react-i18next';

function useChartDateFormatter() {
  const { t } = useTranslation();
  return {
    format: (params: {
      timestamp?: string | number;
      interval?: TimeRangeEnum;
    }) => {
      const { timestamp, interval = '24h' } = params;
      return dayjs(timestamp)
        .utc()
        .format(
          interval === '24h'
            ? t('common.momentDateFormat')
            : t('common.momentShortDateFormat')
        );
    },
  };
}

export default useChartDateFormatter;
